// extracted by mini-css-extract-plugin
export var attribution = "_9c-4";
export var authorName = "_9c-5";
export var quote = "_9c-3";
export var testimonial = "_9c-2";
export var trustedBy = "_9c-0";
export var trustedByLabel = "_9c-1";